/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBuilding = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M5.5 3H14v8h4.5c1.5 0 1.5 1.5 1.5 1.5V21H4V3zM8 5H6v2h2zm4 0v2h-2V5zM6 9h2v2H6zm4 2h2V9h-2zm-2 2H6v2h2zm4 0v2h-2v-2zm-6 6h2v-2H6zm4 0v-2h2v2zm8-6h-2v2h2zm0 4v2h-2v-2z" clipRule="evenodd" /></svg>;
export default SvgBuilding;